import SecurityForm from './SecurityForm'

export default SecurityForm
